import {Alert, Button, Card, Col, Divider, Form, Input, message, Modal, Radio, Row, Space, Spin} from "antd";
import {
    CheckCircleOutlined,
    DownloadOutlined,
    ExclamationCircleOutlined,
    EyeOutlined,
    RedoOutlined,
} from "@ant-design/icons";
import {useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBank, faCreditCard, faMoneyBillTransfer, faRepeat, faUser} from "@fortawesome/free-solid-svg-icons";
import {MSG_FAILED_TO_FETCH_DOCUMENTS_ERROR} from "../../../util/Messages";
import {AccountWiseFundDetailWrapperDto} from "../../../dto/AccountWiseFundDetailWrapperDto";
import {API_RESPONSE_STATUS, PREVIEW_DOC_TYPES, WITHDRAW_TYPE_TAG, YYYY_MM_DD} from "../../../util/Constants";
import CustomerTransactionListTable from "./customerTransactionListTableComp";
import {AccountWiseFundDetailDto} from "../../../dto/AccountWiseFundDetailDto";
import ErrorHandler from "../../../util/ErrorHandler";
import TextArea from "antd/es/input/TextArea";
import transactionService from "../../../service/transactionService";
import {AuthorizeTransactionDto} from "../../../dto/AuthorizeTransactionDto";
import modal from "antd/es/modal";
import documentService from "../../../service/documentService";
import {UploadedDocumentDetailDto} from "../../../dto/UploadedDocumentDetailDto";
import Validation from "../../../util/Validation";
import PreviewModalComp from "../../common/preview/PreviewModalComp";
import {ThirdPartyBankDetailDto} from "../../../dto/ThirdPartyBankDetailDto";
import {BankDetailDto} from "../../../dto/BankDetailDto";
import {StopOutlined} from "@ant-design/icons/lib";
import dayjs from "dayjs";

interface TransactionMoneyRequestProps {
    transactionSwitchMoneyData: AccountWiseFundDetailWrapperDto[]
    isLoading: boolean
    transactionType: string
    documentCode: string
    reloadTable: () => void
}

const TRANSACTION_TYPE_TRANSFER = "TRANSFER"

const transactionTypeNames = {
    SWITCH: "Switch",
    WITHDRAW: "Withdraw",
    TRANSFER: "Transfer",
};
const CommonSwitchWithdrawTransferMoneyComp = (props: TransactionMoneyRequestProps) => {
    const [fromForm] = Form.useForm()
    const [toForm] = Form.useForm()
    const [withdrawForm] = Form.useForm()

    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [isLoading, setLoading] = useState<boolean>(false);
    const [transferMoneyRequestDocument, setTransferMoneyRequestDocument] = useState<UploadedDocumentDetailDto>();
    const [docURL, setDocURL] = useState('');
    const [previewOpen, setPreviewOpen] = useState(false);
    const [docType, setDocType] = useState<PREVIEW_DOC_TYPES>(PREVIEW_DOC_TYPES.IMAGE);
    const [documentName, setDocumentName] = useState<string>("");
    const [apiResponseStatus, setApiResponseStatus] = useState<string | null>(null);
    const [isRejectReasonModalOpen, setRejectReasonModalOpen] = useState(false);
    const [reasonModalTitle, setReasonModalTitle] = useState<string>("Reject");
    const [isThirdPartyBankAcc, setIsThirdPartyBankAcc] = useState(false);
    const [isFullAmountTransaction, setFullAmountTransaction] = useState(false);
    const [isNewTemplate, setNewTemplate] = useState(false);
    const [isScheduledTransaction, setIsScheduledTransaction] = useState(false);
    const [accountType, setAccountType] = useState("");
    const [modalData, setModalData] = useState<AccountWiseFundDetailWrapperDto>({
        requestId: 0,
        cin: "",
        portFolioNumber: "",
        portFolioId: 0,
        customerName: "",
        requestedDate: "",
        accountType: "",
        transactionTag: "",
        requestList: []
    });
    const [transferFromAlert, setTransferFromAlert] = useState<any>();
    const [transferToAlert, setTransferToAlert] = useState<any>();

    const showModal = (data: AccountWiseFundDetailWrapperDto) => {
        const modalData: AccountWiseFundDetailDto[] = data.requestList
        setModalData(data)
        if (modalData && modalData.length > 0) {
            setFullAmountTransaction(modalData[0].fullAmountSelection as boolean)
            if (props.transactionType !== "WITHDRAW") {
                setTransferOrSwitchFormData(modalData)
            } else {
                let tag = WITHDRAW_TYPE_TAG.SCHEDULE_WITHDRAW_MONEY_SCHEDULED === data.transactionTag ? WITHDRAW_TYPE_TAG.SCHEDULE_WITHDRAW_MONEY_SWP : data.transactionTag;
                setWithdrawFormData(modalData[0], tag)
            }

            setApiResponseStatus(modalData[0].apiResponseStatus as string);

        }
        setIsModalOpen(true);

    };

    const getFailedMessages = (data: string) => {
        if (null != data) {
            const errorList = data.split(';');

            return (
                <Alert type="error" message="Error Log" showIcon
                       description={<ul style={{padding: '0 10px 0 18px', width: '100%'}}>
                           {errorList.map((error, index) => (
                               <li key={index}>{error}</li>
                           ))}
                       </ul>}/>
            );
        }
    }

    const setTransferOrSwitchFormData = (modalData: AccountWiseFundDetailDto[]) => {
        const fromFormData: AccountWiseFundDetailDto = modalData[0]
        fromForm.setFieldsValue({
            portfolioId: fromFormData.portfolioNumber,
            fund: fromFormData.fundName,
            amount: toFixed(Math.abs(fromFormData.fundAmount)),
            transactionVerificationStatusFrom: fromFormData.transactionVerificationStatus,
        })

        setTransferFromAlert(getFailedMessages(fromFormData.apiFailedReason))
        if (fromFormData.transactionDocumentId && fromFormData.transactionDocumentId != null) {
            loadDocument(fromFormData.transactionDocumentId, fromFormData.jobNumber,
                props.documentCode)
        }

        if (modalData && modalData.length > 1) {
            const toFormData: AccountWiseFundDetailDto = modalData[1]

            if (props.transactionType === TRANSACTION_TYPE_TRANSFER) {
                toForm.setFieldsValue({
                    customerName: toFormData.customerName,
                    portfolioId: toFormData.portfolioNumber,
                    accountType: toFormData.accountType,
                    transactionVerificationStatusTo: toFormData.transactionVerificationStatus
                })
                setAccountType(toFormData.accountType)
                setTransferToAlert(getFailedMessages(toFormData.apiFailedReason))
            } else {
                toForm.setFieldsValue({
                    fund: toFormData.fundName,
                    portfolioId: toFormData.portfolioNumber,
                    transactionVerificationStatusTo: toFormData.transactionVerificationStatus
                })
            }

        }
    }
    const toFixed = (value: number | undefined): any => {
        if (undefined != value) {
            let val = value.toString();
            if (val.indexOf(".") != -1) {
                val = val.slice(0, (val.indexOf(".")) + 3);
            }
            val = (+val).toFixed(2);
            return val.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
        return "0.00";
    }
    const setWithdrawFormData = (withdrawFormData: AccountWiseFundDetailDto, transactionTag: string) => {
        withdrawForm.setFieldsValue({
            portfolioId: withdrawFormData.portfolioNumber,
            fund: withdrawFormData.fundName,
            amount: toFixed(Math.abs(withdrawFormData.fundAmount)),
            withdrawType: transactionTag,
        })
        if (withdrawFormData.transactionDocumentId && withdrawFormData.transactionDocumentId != null) {
            loadDocument(withdrawFormData.transactionDocumentId, withdrawFormData.jobNumber,
                props.documentCode)
        }
        if (withdrawFormData.bankDetailDto) {
            setIsThirdPartyBankAcc(false)
            const bankDetailDto: BankDetailDto = withdrawFormData.bankDetailDto

            withdrawForm.setFieldsValue({
                bankName: bankDetailDto.bankName,
                branchName: bankDetailDto.branchName,
                accountNo: bankDetailDto.accountNo,
                accountHolderName: bankDetailDto.accountHolderName,
            })
        }

        if (withdrawFormData.thirdPartyBankDetailsDto) {
            setIsThirdPartyBankAcc(true)
            const thirdPartyBankDetailDto: ThirdPartyBankDetailDto = withdrawFormData.thirdPartyBankDetailsDto
            let isNewTemplate = "OTHER" === withdrawFormData.thirdPartyBankType;
            setNewTemplate(isNewTemplate)
            withdrawForm.setFieldsValue({
                bankName: thirdPartyBankDetailDto.bankName,
                branchName: thirdPartyBankDetailDto.branchName,
                accountNo: thirdPartyBankDetailDto.accountNo,
                // bankCode: thirdPartyBankDetailDto.bankName,
                templateName: thirdPartyBankDetailDto.accountNickName,
                accountHolderName: thirdPartyBankDetailDto.accountName,
                bankAccount: "Other",
                existingTemplate: isNewTemplate ? "Other" : thirdPartyBankDetailDto.accountNickName,
            })
        }

        if (transactionTag !== WITHDRAW_TYPE_TAG.WITHDRAW_MONEY) {
            setIsScheduledTransaction(true)
            withdrawForm.setFieldsValue({
                withdrawalFrequency: withdrawFormData.transactionTag === WITHDRAW_TYPE_TAG.SCHEDULE_WITHDRAW_MONEY_SWP ? "Monthly" : "One Time",
                withdrawalDate: dayjs(withdrawFormData.transactionScheduledDateTime).format(YYYY_MM_DD)

            })
        } else {
            setIsScheduledTransaction(false)
        }

    }
    const loadDocument = (documentDetailId: number, jobNumber: number, type: string) => {
        setLoading(true)
        documentService.getUploadDocumentListByTypeAndUploadedDocId(jobNumber, documentDetailId, [type]).then(res => {
            if (res.data.status == 'SUCCESS') {
                setLoading(false)
                setTransferMoneyRequestDocument(res.data.results[0].uploadDocumentDetailDto);
            }
            setLoading(false)
        }, (reason) => {
            setLoading(false)
            ErrorHandler.handleError(reason);
        });
    }

    const openModal = (document: UploadedDocumentDetailDto | undefined) => {
        if (document) {
            setLoading(true)
            documentService.viewOriginalDocument(document.uploadDocumentDetailId.toString()).then(res => {
                if (res.data !== null) {
                    setPreviewOpen(true)
                    setIsModalOpen(false)
                    setDocURL(res.data.results)
                    setDocType(Validation.checkDocumentContentType(res.data.results))
                    setDocumentName(document.originalDocumentName)
                    setLoading(false)
                } else {
                    message.error(MSG_FAILED_TO_FETCH_DOCUMENTS_ERROR).then();
                    setLoading(false)
                }
            }, (reason) => {
                ErrorHandler.handleError(reason);
                setLoading(false)
            })
            return true;
        }

    };

    const handlePreviewCancel = () => {
        fromForm.resetFields()
        toForm.resetFields()
        setTransferMoneyRequestDocument(null)
        setPreviewOpen(false);
    };

    const download = (val: string, docName: string) => {
        let a = document.createElement('a');
        a.href = val;
        a.download = docName;
        a.click();
    }
    const handleCancel = () => {
        fromForm.resetFields()
        toForm.resetFields()
        setTransferMoneyRequestDocument(null)
        setIsModalOpen(false);
    };
    const handleRejectReasonCancel = () => {
        setRejectReasonModalOpen(false)
        setLoading(false)
    }
    const rejectRequest = () => {

        modal.confirm({
            title: 'Confirm',
            className: 'confirm-dialog-box',
            icon: <ExclamationCircleOutlined/>,
            content: `Are you sure?, Do you want to reject this request?`,
            okText: 'Yes',
            cancelText: 'No',
            okButtonProps: {style: {background: '#FF7400'}},
            onOk() {
                setLoading(true)
                setReasonModalTitle("Reject")
                setRejectReasonModalOpen(true)
            },
            onCancel() {
                setLoading(false)
            }
        });

    }

    const cancelRequest = () => {

        modal.confirm({
            title: 'Confirm',
            className: 'confirm-dialog-box',
            icon: <ExclamationCircleOutlined/>,
            content: `Are you sure?, Do you want to cancel this request?`,
            okText: 'Yes',
            cancelText: 'No',
            okButtonProps: {style: {background: '#FF7400'}},
            onOk() {
                setLoading(true)
                setReasonModalTitle("Cancel")
                setRejectReasonModalOpen(true)
            },
            onCancel() {
                setLoading(false)
            }
        });

    }
    const rejectRequestSubmit = (val: { rejectReason: string }) => {
        setRejectReasonModalOpen(false)
        acceptOrRejectRequest("REJECTED", val.rejectReason, reasonModalTitle.toUpperCase())
    }
    const acceptRequest = () => {

        modal.confirm({
            title: 'Confirm',
            className: 'confirm-dialog-box',
            icon: <ExclamationCircleOutlined/>,
            content: `Are you sure?, Do you want to accept this request?`,
            okText: 'Yes',
            cancelText: 'No',
            okButtonProps: {style: {background: '#FF7400'}},
            onOk() {
                setLoading(true)
                acceptOrRejectRequest("ACCEPTED", "", "ACCEPTED")
            },
            onCancel() {
                setLoading(false)
            }
        });
    }
    const retryRequest = () => {

        modal.confirm({
            title: 'Confirm',
            className: 'confirm-dialog-box',
            icon: <ExclamationCircleOutlined/>,
            content: `Are you sure?, Do you want to retry this request?`,
            okText: 'Yes',
            cancelText: 'No',
            okButtonProps: {style: {background: '#FF7400'}},
            onOk() {
                setLoading(true)
                acceptOrRejectRequest("ACCEPTED", "", "RETRY")
            },
            onCancel() {
                setLoading(false)
            }
        });
    }

    const acceptOrRejectRequest = (type: string, rejectedUser: string, messageType: string) => {
        const requestData = {
            transactionRejectReason: rejectedUser,
            transactionStatus: type,
            transactionDetailsId: modalData.requestId,
            portfolioId: modalData.portFolioId,
            cin: modalData.cin
        } as AuthorizeTransactionDto
        transactionService.authorizeTransactions(requestData).then(() => {
            setLoading(false)
            message.success(messageType === "ACCEPTED" ? "Successfully authorized" : messageType === "RETRY" ? "Successfully retried" : messageType === "REJECT" ? "Successfully rejected" : "Successfully cancelled")
            setIsModalOpen(false)

            props.reloadTable()
        }).catch((res) => {
            setLoading(false)
            setIsModalOpen(false)
            setRejectReasonModalOpen(false)
            ErrorHandler.handleError(res)
        })
    }

    const transactionTypeName = transactionTypeNames[props.transactionType]

    const getTransferOrSwitchFormData = () => {
        return <>
            <Col span={24}>
                {isFullAmountTransaction ?
                    <Alert
                        message="Full amount transaction."
                        type="warning" showIcon className={'margin_bottom_20'}/>
                    : <></>}
                <Card title={transactionTypeName + " Money From"} size={'small'}>
                    <Form
                        className='form-input'
                        layout={"vertical"}
                        form={fromForm}
                        disabled
                    >
                        <Row gutter={[12, 0]}>
                            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Form.Item
                                    label="Portfolio ID"
                                    name={'portfolioId'}>
                                    <Input size={'large'}/>

                                </Form.Item>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Form.Item
                                    label="Fund"
                                    name={'fund'}>
                                    <Input size={'large'}/>
                                </Form.Item>
                            </Col>

                            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Form.Item
                                    label="Amount"
                                    name={'amount'}>
                                    <Input size={'large'}/>
                                </Form.Item>
                            </Col>
                            {TRANSACTION_TYPE_TRANSFER == props.transactionType ?

                                <>
                                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <Form.Item
                                            label="Status"
                                            name={'transactionVerificationStatusFrom'}>
                                            <Input size={'large'}/>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                        {transferFromAlert}
                                    </Col>
                                </>
                                :
                                <></>
                            }
                            {transferMoneyRequestDocument ?
                                <Col span={24} style={{marginBottom: 16, paddingRight: 28}}>
                                    <Form.Item className={'form-item-label-only'}
                                               label={transactionTypeName + " Transaction Document"}>
                                    </Form.Item>
                                    <div className='utility_bill img-nic'>
                                        <div className='utulity_bill_icon_div'>
                                            <div className="img_div">
                                                <img src={transferMoneyRequestDocument?.thumbB64} alt=""/>
                                            </div>
                                            <div className='name_div'>
                                                <h5>{transferMoneyRequestDocument?.documentTypeName}</h5>
                                            </div>
                                        </div>
                                        <Button className='doc-view-btn' disabled={false}
                                                onClick={() => openModal(transferMoneyRequestDocument)}
                                        ><EyeOutlined/></Button>
                                    </div>
                                </Col> : <></>}
                        </Row>
                    </Form>
                </Card>
            </Col>
            <Col span={24} style={{marginTop: 12}}>
                <Card title={transactionTypeName + " Money To"} size={'small'}>
                    <Form
                        className='form-input'
                        layout={"vertical"}
                        form={toForm}
                        disabled
                    >
                        <Row gutter={[12, 0]}>
                            {
                                props.transactionType === TRANSACTION_TYPE_TRANSFER ?
                                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        <Form.Item
                                            label={'Account Type'}
                                            name={"accountType"}>
                                            <Radio.Group optionType="button"
                                                         buttonStyle="solid"
                                                         className='modal-template-screen-radio-btn'
                                            >

                                                <Radio.Button value={'OWN'}><FontAwesomeIcon icon={faUser}
                                                                                             className='radio-btn-icon'/> Own
                                                    Account</Radio.Button>
                                                <Radio.Button value={'OTHER'}><FontAwesomeIcon icon={faBank}
                                                                                               className='radio-btn-icon'/> Other
                                                    Account</Radio.Button>

                                            </Radio.Group>
                                        </Form.Item>
                                    </Col> : ''
                            }

                            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Form.Item
                                    label="Portfolio ID"
                                    name={'portfolioId'}>
                                    <Input size={'large'}/>

                                </Form.Item>
                            </Col>


                            {
                                props.transactionType === TRANSACTION_TYPE_TRANSFER ?
                                    accountType == "OTHER" ?
                                        <>
                                            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <Form.Item
                                                    label="Name"
                                                    name={'customerName'}>
                                                    <Input size={'large'}/>

                                                </Form.Item>
                                            </Col>
                                            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <Form.Item
                                                    label="Status"
                                                    name={'transactionVerificationStatusTo'}>
                                                    <Input size={'large'}/>
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                {transferToAlert}
                                            </Col>
                                        </>
                                        :
                                        <>
                                            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <Form.Item
                                                    label="Status"
                                                    name={'transactionVerificationStatusTo'}>
                                                    <Input size={'large'}/>
                                                </Form.Item>

                                            </Col>
                                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                {transferToAlert}
                                            </Col>
                                        </>
                                    :
                                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <Form.Item
                                            label="Fund"
                                            name={'fund'}>
                                            <Input size={'large'}/>

                                        </Form.Item>
                                    </Col>
                            }


                        </Row>
                    </Form>
                </Card>
            </Col>
        </>
    }

    const getWithdrawFormData = () => {
        return <>
            <Col span={24}>
                {isFullAmountTransaction ?
                    <Alert
                        message="Full amount transaction."
                        type="warning" showIcon className={'margin_bottom_20'}/>
                    : <></>}
                <Card title="Request Details" size={'small'}>
                    <Form
                        className='form-input'
                        layout={"vertical"}
                        form={withdrawForm}
                        disabled
                    >
                        <Row gutter={[12, 0]}>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                <Form.Item
                                    label="Withdraw Type"
                                    name={"withdrawType"}>
                                    <Radio.Group optionType="button"
                                                 buttonStyle="solid"
                                                 className='modal-template-screen-radio-btn'
                                    >

                                        <Radio.Button value={WITHDRAW_TYPE_TAG.WITHDRAW_MONEY}>
                                            <FontAwesomeIcon icon={faUser}
                                                             className='radio-btn-icon'/> Online
                                        </Radio.Button>
                                        <Radio.Button value={WITHDRAW_TYPE_TAG.SCHEDULE_WITHDRAW_MONEY_SWP}>
                                            <FontAwesomeIcon icon={faBank} className='radio-btn-icon'/> Schedule/SWP
                                        </Radio.Button>

                                    </Radio.Group>
                                </Form.Item>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Form.Item
                                    label="Portfolio ID"
                                    name={'portfolioId'}>
                                    <Input size={'large'}/>

                                </Form.Item>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Form.Item
                                    label="Fund"
                                    name={'fund'}>
                                    <Input size={'large'}/>
                                </Form.Item>
                            </Col>

                            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Form.Item
                                    label="Amount"
                                    name={'amount'}>
                                    <Input size={'large'}/>
                                </Form.Item>
                            </Col>
                            {isThirdPartyBankAcc ?
                                <>
                                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <Form.Item
                                            label="Bank Account"
                                            name={'bankAccount'}>
                                            <Input size={'large'}/>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <Form.Item
                                            label="Exisiting Template"
                                            name={'existingTemplate'}>
                                            <Input size={'large'}/>
                                        </Form.Item>
                                    </Col>
                                </>
                                : <></>}
                            {
                                isScheduledTransaction ?
                                    <>
                                        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <Form.Item
                                                label="Withdrawal Frequency"
                                                name={'withdrawalFrequency'}>
                                                <Input size={'large'}/>
                                            </Form.Item>
                                        </Col>
                                        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <Form.Item
                                                label="Withdrawal Date"
                                                name={'withdrawalDate'}>
                                                <Input size={'large'}/>
                                            </Form.Item>
                                        </Col>
                                    </> : ''
                            }
                        </Row>
                        <h4 style={{marginBottom: 12}}>
                            {isThirdPartyBankAcc ? "Third Party " : ""}Bank Details</h4>

                        <Row gutter={[12, 0]}>
                            {isNewTemplate ? <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Form.Item
                                    label="Template Name"
                                    name={'templateName'}>
                                    <Input size={'large'}/>
                                </Form.Item>
                            </Col> : <></>}
                            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Form.Item
                                    label="Bank Name"
                                    name={'bankName'}>
                                    <Input size={'large'}/>
                                </Form.Item>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Form.Item
                                    label="Bank Branch"
                                    name={'branchName'}>
                                    <Input size={'large'}/>
                                </Form.Item>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Form.Item
                                    label="Account Number"
                                    name={'accountNo'}>
                                    <Input size={'large'}/>
                                </Form.Item>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Form.Item
                                    label="Account Holder's Name"
                                    name={'accountHolderName'}>
                                    <Input size={'large'}/>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={[12, 0]}>
                            {transferMoneyRequestDocument ?
                                <Col span={24} style={{marginBottom: 16, paddingRight: 28}}>
                                    <Form.Item className={'form-item-label-only'}
                                               label={transactionTypeName + " Transaction Document"}>
                                    </Form.Item>
                                    <div className='utility_bill img-nic'>
                                        <div className='utulity_bill_icon_div'>
                                            <div className="img_div">
                                                <img src={transferMoneyRequestDocument?.thumbB64} alt=""/>
                                            </div>
                                            <div className='name_div'>
                                                <h5>{transferMoneyRequestDocument?.documentTypeName}</h5>
                                            </div>
                                        </div>
                                        <Button className='doc-view-btn' disabled={false}
                                                onClick={() => openModal(transferMoneyRequestDocument)}
                                        ><EyeOutlined/></Button>
                                    </div>
                                </Col> : <></>}
                        </Row>
                    </Form>
                </Card>
            </Col>

        </>
    }
    return (
        <Spin spinning={isLoading}>
            <Row gutter={[16, 16]} className={transactionTypeName}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} className='page-header-main-title-col'>
                    <h2 className='page-header-main-title'
                        style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                        <div className='header_icon header-icon-center'>
                            <FontAwesomeIcon
                                icon={transactionTypeName === 'Transfer' ? faMoneyBillTransfer : transactionTypeName === 'Withdraw' ? faCreditCard : faRepeat}
                            />
                        </div>
                        {transactionTypeName} Money Requests
                    </h2>
                </Col>
            </Row>
            <Row gutter={[24, 12]}>
                <Col span={24}>
                    <CustomerTransactionListTable tableData={props.transactionSwitchMoneyData}
                                                  loading={props.isLoading} onShowModal={showModal}
                                                  transactionType={props.transactionType}
                    />
                </Col>
            </Row>
            <Modal title={transactionTypeName + " Money Request"} open={isModalOpen} footer={null}
                   onCancel={handleCancel}
                   width={800}
                   centered style={{top: 20, paddingBottom: 20}}
                   className={'modal-body-scroll-only disabled-data-show-inputs-container'}>
                <Spin spinning={isLoading}>
                    <Row gutter={[24, 12]} className={'form-item-mb-12 modal-body-scroll-only-main-row'}
                         style={{marginTop: 18}}>
                        {
                            props.transactionType !== "WITHDRAW" ?
                                getTransferOrSwitchFormData() :
                                getWithdrawFormData()
                        }

                        <Col span={24}>
                            <Divider style={{marginBottom: 12}}></Divider>
                        </Col>

                        <Col span={24} className={'request-auth-modal-btns-row'}>
                            {API_RESPONSE_STATUS.PENDING === apiResponseStatus ?
                                <Space style={{float: 'right'}}>

                                    <Button danger onClick={rejectRequest}
                                            style={{
                                                width: 100,
                                                marginRight: 8
                                            }}><StopOutlined/> Reject</Button>
                                    <Button type="success" onClick={acceptRequest}
                                            style={{
                                                width: 100,
                                                background: "#008d86",
                                                color: "white",
                                            }}><CheckCircleOutlined/> Accept</Button>
                                </Space>
                                : API_RESPONSE_STATUS.FAILED === apiResponseStatus ?
                                    <Space style={{float: 'right'}}>

                                        {props.transactionType !== TRANSACTION_TYPE_TRANSFER ?
                                            <Button danger onClick={cancelRequest}
                                                    style={{
                                                        width: 100,
                                                        marginRight: 8
                                                    }}><StopOutlined/> Cancel</Button>
                                            :
                                            <></>
                                        }
                                        <Button type="success" onClick={retryRequest}
                                                style={{
                                                    width: 100,
                                                    background: "#008d86",
                                                    color: "white",
                                                }}><RedoOutlined/> Retry</Button>
                                    </Space> : <></>
                            }
                        </Col>
                    </Row>
                </Spin>


            </Modal>
            <Modal title={`${reasonModalTitle} Reason`}
                   open={isRejectReasonModalOpen}
                   destroyOnClose={true}
                   maskClosable={false}
                   footer={null}
                   onCancel={handleRejectReasonCancel}
            >
                <Row>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Form
                            layout={"vertical"}
                            initialValues={{remember: true}}
                            onFinish={rejectRequestSubmit}
                        >
                            <Form.Item
                                name={"rejectReason"}
                                label={`${reasonModalTitle} Reason`}
                                rules={[{
                                    required: true,
                                    message: `Please enter ${reasonModalTitle.toLowerCase()} reason`
                                }]}>
                                <TextArea showCount
                                          placeholder={`Please enter ${reasonModalTitle.toLowerCase()} reason`}
                                          maxLength={255}
                                          bordered={true}/>
                            </Form.Item>
                            <Form.Item>
                                <Space style={{float: 'right'}}>
                                    <Button onClick={handleRejectReasonCancel}>
                                        Cancel
                                    </Button>
                                    <Button htmlType="submit"
                                            type="primary">
                                        Submit
                                    </Button>
                                </Space>
                            </Form.Item>


                        </Form>
                    </Col>
                </Row>

            </Modal>
            <Modal
                className={docType == PREVIEW_DOC_TYPES.PDF ? "modal-custom-bg" : "image-view-modal"}
                open={previewOpen}
                centered
                title={documentName}
                onCancel={handlePreviewCancel}
                destroyOnClose={true}
                width={docType == PREVIEW_DOC_TYPES.PDF ? 800 : 600}
                footer={[
                    <Button type="primary" icon={<DownloadOutlined/>} style={{background: '#FF7400', height: 40}}
                            htmlType="submit" onClick={() => download(docURL, documentName)}>
                        Download
                    </Button>]}>
                <PreviewModalComp docURL={docURL}/>
            </Modal>
        </Spin>
    )
}
export default CommonSwitchWithdrawTransferMoneyComp;